import { getShippingCardsApi } from "./getShippingCardsApi";

export const getShippingCardsSetData = async (
  lang,
  setMessageResponse,
  cookies,
  setCardsData
) => {
  const response = await getShippingCardsApi(lang, cookies);
  if (response.success) {
    setCardsData(() => response.res.data.data);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
